<template>
  <div class="flex gap-2 w-full">
    <div
      v-for="step in stepsArray"
      :key="step"
      @click="handleClick(step)"
      class="h-[6px] w-full rounded transition-colors"
      :class="[
        props.stepToWatch >= step ? 'bg-navbar-invest-bg-tracked' : 'bg-navbar-invest-bg-track',
        !props.disabled && step < props.stepToWatch ? 'cursor-pointer hover:opacity-80' : '',
      ]"
    ></div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  numSteps: {
    type: Number,
    required: true,
  },
  stepToWatch: {
    type: Number,
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["set-active-step"]);

const stepsArray = computed(() => Array.from({ length: props.numSteps }, (_, i) => i + 1));

const handleClick = (step) => {
  if (!props.disabled && step < props.stepToWatch) {
    emit("set-active-step", step);
  }
};
</script>
